export const parseExcelInteger = (value: unknown): number | null => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return Math.round(value);
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return null;
    const parsed = Number(trimmed.replace(/,/g, '.'));
    return Number.isFinite(parsed) ? Math.round(parsed) : null;
  }

  return null;
};
